import ProfilePictureGroupNamed from './ProfilePictureGroupNamed'

export default ProfilePictureGroupNamed
